import Card from '../../components/card/Card';
import H from '../../components/texts/h/H';
import Input from '../../components/input/Input';

interface ProtectorData {
  company_name: string;
  cuit: string;
  email: string;
  registration_date: string;
  document_type_name: string;
  legal_entity_type_name: string;
  meeting_minute_type_name: string;
  minute_number: string;
}

interface ProtectorDetailsBasicSectionProps {
  protector: ProtectorData;
}

const ProtectorDetailsBasicSection = ({ protector }: ProtectorDetailsBasicSectionProps) => {
  const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch {
      return dateString;
    }
  };

  return (
    <Card margin={{ bottom: '4' }}>
      <Card margin={{ bottom: '3' }}>
        <H variant="secondary-2" type='4' weight='bold' modifier='strong'>
          Datos del protector
        </H>
      </Card>
      
      {/* Fila 1 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px', alignItems: 'end' }}>
        <Input
          label="Razón social"
          value={protector.company_name || '-'}
          readOnly
          size="md"
          modifier="weak"
        />
        <Input
          label="CUIT"
          value={protector.cuit || '-'}
          readOnly
          size="md"
          modifier="weak"
        />
        <Input
          label="Email"
          value={protector.email || '-'}
          readOnly
          size="md"
          modifier="weak"
        />
        <Input
          label="Fecha de registro"
          value={formatDate(protector.registration_date)}
          readOnly
          size="md"
          modifier="weak"
        />
      </div>

      {/* Fila 2 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', alignItems: 'end' }}>
        <Input
          label="Tipo de documento"
          value={protector.document_type_name || '-'}
          readOnly
          size="md"
          modifier="weak"
        />
        <Input
          label="Entidad legal"
          value={protector.legal_entity_type_name || '-'}
          readOnly
          size="md"
          modifier="weak"
        />
        <Input
          label="Tipo de acta"
          value={protector.meeting_minute_type_name || '-'}
          readOnly
          size="md"
          modifier="weak"
        />
        <Input
          label="Número de acta"
          value={protector.minute_number || '-'}
          readOnly
          size="md"
          modifier="weak"
        />
      </div>
    </Card>
  );
};

export default ProtectorDetailsBasicSection;

